const teams = [
  {
    title: "For Head of Collections",
    description:
      "Increase agent productivity by 15-20% with AI-prioritized queues and automated reminders.",
    textColor: "text-[#dbeafe]",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip-collections)">
          <path d="M17 20H22V18C21.9999 16.722 21.1902 15.5844 19.9827 15.1658C18.7753 14.7471 17.4352 15.1394 16.644 16.143M17 20H7M17 20V18C17 17.344 16.874 16.717 16.644 16.143M7 20H2V18C2.00009 16.722 2.80979 15.5844 4.01725 15.1658C5.22471 14.7471 6.56484 15.1394 7.356 16.143M7 20V18C7 17.344 7.126 16.717 7.356 16.143M7.356 16.143C8.11578 14.2443 9.9549 12.9993 12 12.9993C14.0451 12.9993 15.8842 14.2443 16.644 16.143M15 7C15 8.65575 13.6557 10 12 10C10.3443 10 9 8.65575 9 7C9 5.34425 10.3443 4 12 4C13.6557 4 15 5.34425 15 7Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
          <clipPath id="clip-collections">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    title: "For CTO / Engineering",
    description:
      "Modern API-first stack. Self-hosted option. Full source access. Deploy in hours.",
    textColor: "text-[#f3e8ff]",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 20L14 4M18 8L22 12L18 16M6 16L2 12L6 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    title: "For COO / CEO",
    description:
      "Real-time visibility into portfolio health and recovery trends.",
    textColor: "text-[#dcfce7]",
    icon: (
    <svg
  className="shrink-0 w-6 h-6 relative overflow-visible"
  style={{ aspectRatio: 1 }}
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path d="M3.75 18H20.25V19.5H3.75V18Z" fill="white" />
  <path
    d="M6.75039 16.5002C7.09639 16.0309 7.54865 15.6504 8.07011 15.3896C8.59157 15.1289 9.1674 14.9954 9.75039 15.0002H14.2504C14.8303 15.0123 15.4003 15.1532 15.9192 15.4126C16.438 15.6721 16.8927 16.0435 17.2504 16.5002H18.9754C18.5606 15.598 17.894 14.8349 17.0557 14.3027C16.2175 13.7705 15.2433 13.4918 14.2504 13.5002H9.75039C8.75748 13.4918 7.7833 13.7705 6.94504 14.3027C6.10678 14.8349 5.44017 15.598 5.02539 16.5002H6.75039Z"
    fill="white"
  />
  <path d="M18 21H19.5V22.5H18V21Z" fill="white" />
  <path d="M4.5 21H6V22.5H4.5V21Z" fill="white" />
  <path
    d="M12 12C10.9617 12 9.94662 11.6921 9.08326 11.1152C8.2199 10.5383 7.54699 9.7184 7.14963 8.75909C6.75227 7.79978 6.64831 6.74418 6.85088 5.72578C7.05345 4.70738 7.55347 3.77192 8.28769 3.03769C9.02192 2.30347 9.95738 1.80345 10.9758 1.60088C11.9942 1.39831 13.0498 1.50227 14.0091 1.89963C14.9684 2.29699 15.7883 2.9699 16.3652 3.83326C16.9421 4.69662 17.25 5.71165 17.25 6.75C17.25 8.14239 16.6969 9.47775 15.7123 10.4623C14.7277 11.4469 13.3924 12 12 12ZM12 3C11.0054 3 10.0516 3.39509 9.34835 4.09835C8.64509 4.80161 8.25 5.75544 8.25 6.75C8.25 7.74456 8.64509 8.69839 9.34835 9.40165C10.0516 10.1049 11.0054 10.5 12 10.5C12.9946 10.5 13.9484 10.1049 14.6517 9.40165C15.3549 8.69839 15.75 7.74456 15.75 6.75C15.75 5.75544 15.3549 4.80161 14.6517 4.09835C13.9484 3.39509 12.9946 3 12 3Z"
    fill="white"
  />
</svg>

    ),
  },
  {
    title: "For CFO",
    description:
      "Lower cost per recovery. Faster digital payments. No per-borrower pricing.",
    textColor: "text-[#ffedd5]",
    icon: (
   <svg
  className="shrink-0 w-6 h-6 relative overflow-visible"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M8 7C8 8.06087 8.42143 9.07828 9.17157 9.82843C9.92172 10.5786 10.9391 11 12 11C13.0609 11 14.0783 10.5786 14.8284 9.82843C15.5786 9.07828 16 8.06087 16 7C16 5.93913 15.5786 4.92172 14.8284 4.17157C14.0783 3.42143 13.0609 3 12 3C10.9391 3 9.92172 3.42143 9.17157 4.17157C8.42143 4.92172 8 5.93913 8 7Z"
    stroke="white"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M6 21V19C6 17.9391 6.42143 16.9217 7.17157 16.1716C7.92172 15.4214 8.93913 15 10 15H13"
    stroke="white"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M21 15H18.5C18.1022 15 17.7206 15.158 17.4393 15.4393C17.158 15.7206 17 16.1022 17 16.5C17 16.8978 17.158 17.2794 17.4393 17.5607C17.7206 17.842 18.1022 18 18.5 18H19.5C19.8978 18 20.2794 18.158 20.5607 18.4393C20.842 18.7206 21 19.1022 21 19.5C21 19.8978 20.842 20.2794 20.5607 20.5607C20.2794 20.842 19.8978 21 19.5 21H17"
    stroke="white"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M19 21V22M19 14V15"
    stroke="white"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>

    ),
  },
];

export default function TeamsSection() {
  return (
    <section
      className="py-24 px-5 md:px-20"
      style={{
        background:
          "linear-gradient(180deg, rgba(250,245,255,1) 0%, rgba(255,255,255,1) 100%)",
      }}
    >
      <div className="max-w-7xl mx-auto px-0 md:px-8 flex flex-col gap-16">
        {/* Header */}
        <div className="flex flex-col gap-4 items-center justify-center">
          <div className="bg-white rounded-full border border-[#bae6fd] pt-2 pr-4 pb-2 pl-4 shadow-sm">
            <span
              className="text-[#0369a1] font-bold text-xs leading-4 uppercase"
              style={{ letterSpacing: "0.6px" }}
            >
              for every team
            </span>
          </div>
          <h2 className="text-[#111827] text-center font-['SpaceGrotesk-Bold',_sans-serif] text-4xl md:text-5xl lg:text-6xl leading-tight font-bold">
            Built for Every Decision Maker
          </h2>
        </div>

        {/* Team Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {teams.map((team) => (
            <div
              key={team.title}
              className="bg-[#0f172a] rounded-3xl p-8 flex flex-col gap-5 overflow-hidden"
              style={{ position: "relative" }}
            >
              {/* Decorative circle */}
              <div className="bg-white/10 rounded-full w-32 h-32 shrink-0 absolute -right-8 -top-8 pointer-events-none" />

              <div className="bg-white/20 rounded-3xl flex items-center justify-center w-12 h-12 shrink-0">
                {team.icon}
              </div>
              <div className="flex flex-col gap-3">
                <h3 className="text-white font-['SpaceGrotesk-Bold',_sans-serif] text-2xl leading-8 font-bold">
                  {team.title}
                </h3>
                <p className={`${team.textColor} font-normal text-lg leading-[29px]`}>
                  {team.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
